import React, { useEffect } from 'react';
import { Row, Col, Spin } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { Aside, Content } from './overview/style';
import Heading from '../../../components/heading/heading';

// const DayCalendar = lazy(() => import('./overview/Day'));
const AuthLayout = WraperContent => {
  return () => {
    const config = useSelector(state => {
      return state.config;
    });

    return (
      <Row>
        <Col xxl={8} xl={9} lg={12} md={8} xs={24}>
          <Aside>
            <div className="auth-side-content">
              <img src={require('../../../static/img/auth/topShape.png')} alt="" className="topShape" />
              <img src={require('../../../static/img/auth/bottomShape.png')} alt="" className="bottomShape" />
              <Content>
                {config && config.sLoading && <Spin />}
                {config && config.logo && <img style={{ width: '150px' }} src={config.logo} alt="" />}

                <br />
                <br />
                <Heading as="h1">{config && config.textLogin && config.textLogin}</Heading>
                {config && config.sLoading && <Spin />}
                {config && !config.sLoading && config.loginImage && (
                  <img width="380" className="auth-content-figure" src={config.loginImage} alt="" />
                )}
                {config && !config.sLoading && !config.loginImage && (
                  <img className="auth-content-figure" src={require('~/static/img/auth/Illustration.png')} alt="" />
                )}
                {!config && (
                  <img className="auth-content-figure" src={require('~/static/img/auth/Illustration.png')} alt="" />
                )}
              </Content>
            </div>
          </Aside>
        </Col>

        <Col xxl={16} xl={15} lg={12} md={16} xs={24}>
          <WraperContent />
        </Col>
      </Row>
    );
  };
};

export default AuthLayout;
